import { removeNestedKeyByPath, deepClone } from 'smbls'

export async function handleActiveLayerDeletion(activeLayer) {
  const data = this.getCanvasScope()
  const key = data.activeLayer.pop()
  const schema = deepClone(data.selected.state.parse())
  this.setCanvasMode(false)
  const confirmRemove = `Do you want to remove the "${key}" layer from ${schema.key}?`
  if (!window.confirm(confirmRemove)) {
    return
  }

  removeNestedKeyByPath(schema.component, activeLayer.slice(1).concat(key))
  delete schema.code
  delete schema.codeStr

  const componentType = schema.key.startsWith('/') ? 'pages' : 'components'
  const commitMessage = `${key} layer is removed from ${schema.key} ${componentType}`
  // await this.updateItem(schema, null, { message: commitMessage })
  // await this.updateComponentOnCanvas(schema, { updatePane: true })
}

export async function handleComponentDeletion() {
  const selected = this.getSelected()
  const item = selected?.state
  if (item) this.call('removeCanvasArtboard', item.type, item.key)
  else this.warn('Cant find component')
}
